import { useTranslation } from "react-i18next";
import { useRecoilValue } from "recoil";

import { scannerState } from "bridge/store/scannerState";
import { GoToActivityAction, goToActivity } from "bridge/utils/goToActivity";
import { SubsetOf } from "@becon-team/becon-fe-lib/my-types";

type CrownShooting = ({
  userId,
  userNickname,
  path,
}: {
  userId: string;
  userNickname: string;
  path?: string;
  action: SubsetOf<GoToActivityAction, "ScalpCrownDiagnosis">;
}) => void;

export const useCrownShooting = (): {
  crownShooting: CrownShooting;
} => {
  const { t } = useTranslation();

  const crownShooting: CrownShooting = ({ userId, action, userNickname, path }) => {
    goToActivity(t, action, {
      userId,
      userNickname,
      path,
    });
  };

  return { crownShooting };
};

type ScalpShooting = ({
  userId,
  userNickname,
  currentAction,
  nextAction,
  path,
}: {
  userNickname: string;
  userId: string;
  currentAction: GoToActivityAction;
  nextAction?: GoToActivityAction;
  path?: string;
}) => void;

export const useScalpShooting = (): {
  scalpShooting: ScalpShooting;
  isScannerConnected: boolean;
} => {
  const { t } = useTranslation();
  const isScannerConnected = useRecoilValue(scannerState)?.connectStatus === "complete";

  const scalpShooting: ScalpShooting = ({ userId, userNickname, currentAction, nextAction, path }) => {
    goToActivity(t, currentAction, {
      nextAction,
      userId,
      userNickname,
      path,
    });
  };

  return { scalpShooting, isScannerConnected };
};
